import api from '@/api/scheduled-activations';

const namespaced = true;

export const actions = {
  FETCH_SCHEDULED_ACTIVATIONS: async ({ commit, state, dispatch }) => {
    dispatch('wait/start', 'fetching scheduled activations', { root: true });

    const { pageSize: limit, currentPage } = state;
    const offset = currentPage * limit;

    const { results, count } = await api.fetchScheduledActivations(limit, offset);
    dispatch('wait/end', 'fetching scheduled activations', { root: true });
    commit('SET_ACTIVATIONS', { activations: results });
    commit('SET_ACTIVATIONS_COUNT', { count });
  },

  CANCEL_SCHEDULED_ACTIVATIONS: async (context, scheduledActivationId) => {
    await api.cancelScheduledActivations(scheduledActivationId);
  },
};

export const mutations = {
  SET_PAGE_SIZE(state, { pageSize }) {
    state.pageSize = pageSize;
    state.currentPage = 0;
  },
  SET_CURRENT_PAGE(state, { currentPage }) {
    state.currentPage = currentPage;
  },
  SET_ACTIVATIONS_COUNT(state, { count }) {
    state.count = count;
  },
  SET_ACTIVATIONS(state, { activations }) {
    state.activations = activations;
  },
};

const state = {
  activations: [],
  count: 0,
  pageSize: 15,
  currentPage: 0,
};

export default {
  namespaced,
  actions,
  mutations,
  state,
};
